import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import dateTimeHelper from '../../../../Helpers/datetimeHelper';
import importListHelper from '../../../../Helpers/importListHelper';
import SearchParamsBase from '../../../../Elements/SearchParamsBase';

export default class AssignmentSearchParams extends SearchParamsBase {
  initialize() {
    this.AssignmentApolloIds = '';
    this.CompletedAfter = dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.indefiniteDateValue());
    this.CompletedBefore = dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.indefiniteDateValue());
    this.SelectedCountries = [];
    this.SelectedOfficeIds = [];
    this.AsLgsid = '';
    this.CuLevel1Name = '';
    this.CuLevel2Name = '';
    this.CuLevel3Name = '';
    this.CuLevel4Name = '';
    this.CuLevel5Name = '';
    this.AssignmentType = '';
    this.AsCfId = '';
    this.CuGroupName = '';
    this.AsAdHocGroup = '';
    this.AsWaveName = '';
    this.ProjectIdOrName = '';

    this.ClientFeeTotalFrom = '';
    this.ClientFeeTotalTo = '';
    this.ClientReimbursementTotalFrom = '';
    this.ClientReimbursementTotalTo = '';
    this.EvalFeeTotalFrom = '';
    this.EvalFeeTotalTo = '';
    this.EvalReimbursementTotalFrom = '';
    this.EvalReimbursementTotalTo = '';
  }

  static getStatusValues() {
    return [
      { label: '', value: '', disabled: false },
      { label: 'Created', value: '0', disabled: false },
      { label: 'New', value: '1', disabled: false },
      { label: 'Incomplete', value: '2', disabled: false },
      { label: 'Completed', value: '3', disabled: false },
      { label: 'Collaboration Shop', value: '4', disabled: false },
      { label: 'Excluded', value: '5', disabled: false },
      { label: 'Hold A', value: '6', disabled: false },
      { label: 'Hold B', value: '7', disabled: false },
      { label: 'Reviewed', value: '8', disabled: false },
      { label: 'Finalized', value: '9', disabled: false },
      { label: 'Emailed', value: '10', disabled: false },
      { label: 'Client Finalized', value: '12', disabled: false },
      { label: 'Locked', value: '15', disabled: false },
      { label: 'Deleted in Apollo', value: '23', disabled: false },
    ];
  }

  static tabsOnTheSearchPanel = [
    { label: 'General', id: 'general', icon: 'fa-solid fa-info' },
    // { label: "Fees", id: "fees", icon: "fa-solid fa-money-bill" },
  ];

  static fieldsInSearchBox = [
    {
      fieldName: 'AssignmentApolloIds',
      label: 'Assignment Apollo IDs',
      className: 'col-3',
      type: InputTypesEnum.TextList,
      tooltipText: importListHelper.ListFieldTooltip,
      tab: 'general',
    },
    {
      fieldName: 'CompletedAfter',
      label: 'Completed On or After',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      tab: 'general',
    },
    {
      fieldName: 'CompletedBefore',
      label: 'Completed On or Before',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      tab: 'general',
    },
    {
      fieldName: 'SelectedCountries',
      label: 'Country',
      className: 'col-3',
      type: InputTypesEnum.CountryCodeMultiChoice,
      tab: 'general',
    },
    {
      fieldName: 'SelectedOfficeIds',
      label: 'Fieldwork Office',
      className: 'col-3',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
      tab: 'general',
    },
    {
      fieldName: 'AsLgsid',
      label: 'Status',
      className: 'col-3',
      type: InputTypesEnum.Select,
      options: AssignmentSearchParams.getStatusValues(),
      tab: 'general',
    },
    { fieldName: 'CuLevel1Name', label: 'Level 1', className: 'col-3', type: InputTypesEnum.Text, tab: 'general' },
    { fieldName: 'CuLevel2Name', label: 'Level 2', className: 'col-3', type: InputTypesEnum.Text, tab: 'general' },
    { fieldName: 'CuLevel3Name', label: 'Level 3', className: 'col-3', type: InputTypesEnum.Text, tab: 'general' },
    { fieldName: 'CuLevel4Name', label: 'Level 4', className: 'col-3', type: InputTypesEnum.Text, tab: 'general' },
    { fieldName: 'CuLevel5Name', label: 'Level 5', className: 'col-3', type: InputTypesEnum.Text, tab: 'general' },
    {
      fieldName: 'CuGroupName',
      label: 'Location Group',
      className: 'col-3',
      type: InputTypesEnum.Text,
      tab: 'general',
    },
    { fieldName: 'AsAdHocGroup', label: 'Ad-Hoc Group', className: 'col-4', type: InputTypesEnum.Text, tab: 'general' },
    { fieldName: 'AsWaveName', label: 'Wave', className: 'col-4', type: InputTypesEnum.Text, tab: 'general' },
    {
      fieldName: 'ProjectIdOrName',
      label: "Project (Name or ID or '-' for none)",
      className: 'col-4',
      type: InputTypesEnum.Text,
      tab: 'general',
    },
    // { fieldName: "ClientFeeTotalFrom", label: "Client Fee Total From", className: "col-6", type: InputTypesEnum.NumberWithTwoDecimalPlaces, IsCheckBoxEnabled: true, tab: "fees" },
    // { fieldName: "ClientFeeTotalTo", label: "Client Fee Total To", className: "col-6", type: InputTypesEnum.NumberWithTwoDecimalPlaces, IsCheckBoxEnabled: true, tab: "fees" },
    // { fieldName: "ClientReimbursementTotalFrom", label: "Client Reimbursement Total From", className: "col-6", type: InputTypesEnum.NumberWithTwoDecimalPlaces, IsCheckBoxEnabled: true, tab: "fees" },
    // { fieldName: "ClientReimbursementTotalTo", label: "Client Reimbursement Total To", className: "col-6", type: InputTypesEnum.NumberWithTwoDecimalPlaces, IsCheckBoxEnabled: true, tab: "fees" },
    // { fieldName: "EvalFeeTotalFrom", label: "Eval Fee Total From", className: "col-6", type: InputTypesEnum.NumberWithTwoDecimalPlaces, IsCheckBoxEnabled: true, tab: "fees" },
    // { fieldName: "EvalFeeTotalTo", label: "Eval Fee Total To", className: "col-6", type: InputTypesEnum.NumberWithTwoDecimalPlaces, IsCheckBoxEnabled: true, tab: "fees" },
    // { fieldName: "EvalReimbursementTotalFrom", label: "Eval Reimbursement Total From", className: "col-6", type: InputTypesEnum.NumberWithTwoDecimalPlaces, IsCheckBoxEnabled: true, tab: "fees" },
    // { fieldName: "EvalReimbursementTotalTo", label: "Eval Reimbursement Total To", className: "col-6", type: InputTypesEnum.NumberWithTwoDecimalPlaces, IsCheckBoxEnabled: true, tab: "fees" },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'AssignmentSearchParams';
}
